<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.dictStatus === 'Y' ? 'light' : 'warning'"
        >
          {{ row.dictStatusName }}
        </el-tag>
      </template>
      <template v-slot:systemUse="{ row }">
        <el-tag
          size="mini"
          :type="row.isSystemUse === 'Y' ? 'light' : 'warning'"
        >
          {{ row.isSystemUseName }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_view') || '查看'"
          placement="top"
        >
          <i
            class="el-icon-view tool-btn"
            @click="
              $emit('openEditFormDialog', {
                type: 'detail',
                code: row.keyID,
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_edit') || '编辑'"
          placement="top"
          v-if="allow('M')"
          v-show="row.isSystemUse === 'N'"
        >
          <i
            class="el-icon-edit tool-btn"
            @click="
              $emit('openEditFormDialog', {
                type: 'edit',
                code: row.keyID,
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
          v-show="row.dictStatus != 'N' && row.isSystemUse === 'N'"
          v-if="allow('D')"
        >
          <i class="el-icon-delete tool-btn" @click="del(row.keyID)"></i>
        </el-tooltip>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l("INDEX.table_label_no_data ") || "暂无数据！" }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from "@/mixins/table-auto-height";
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
    components: {},
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: "toolbar_form",
        },
        refresh: {
          query: () => this.$emit("reload"),
        },
      },
      tableColumns: [
        {
          field: "seq",
          width: 50,
          align: "center",
          fixed: "left",
          type: "seq",
        },
        {
          field: "col-opt",
          title: this.$l("INDEX.table_label_operation") || "操作",
          headerAlign: "center",
          align: "left",
          fixed: "left",
          width: 110,
          slots: {
            default: "opt",
          },
        },
        {
          field: "dictType",
          align: "center",
          width: 150,
          title: this.$l("table_label_dict_type") || "字典类型",
          showHeaderOverflow: "title",
          showOverflow: "ellipsis",
        },
        {
          field: "dictValue",
          headerAlign: "center",
          align: "left",
          width: 150,
          title: this.$l("table_label_dict_value") || "内码值",
          showHeaderOverflow: "title",
          showOverflow: "ellipsis",
        },
        {
          field: "dictText",
          headerAlign: "center",
          align: "left",
          width: 150,
          title: this.$l("table_label_dict_text") || "中文显示名字",
          showHeaderOverflow: "title",
          showOverflow: "ellipsis",
        },
        {
          field: "dictTextEn",
          headerAlign: "center",
          align: "left",
          width: 150,
          title: this.$l("table_label_dict_text_en") || "英文显示名字",
          showHeaderOverflow: "title",
          showOverflow: "ellipsis",
        },
        {
          field: "dictDescription",
          headerAlign: "center",
          align: "left",
          minWidth: 200,
          title: this.$l("table_label_dict_description") || "字典说明",
          showHeaderOverflow: "title",
          showOverflow: "ellipsis",
        },
        {
          field: "dictStatusName",
          headerAlign: "center",
          align: "center",
          width: 100,
          title: this.$l("table_label_dict_status") || "有效状态",
          slots: { default: "status" },
          showHeaderOverflow: "title",
          showOverflow: "ellipsis",
        },
        {
          field: "isSystemUseName",
          headerAlign: "center",
          align: "center",
          width: 100,
          title: this.$l("table_label_system_use") || "是否系统使用",
          slots: { default: "systemUse" },
          showHeaderOverflow: "title",
          showOverflow: "ellipsis",
        },
      ],
    };
  },
  methods: {
    del(code) {
      this.$confirm(
        this.$l("INDEX.tips_delete") || "是否要删除该记录？",
        this.$l("INDEX.label_completeDesc") || "确认信息",
        {
          confirmButtonText:
            this.$l("INDEX.product_dialog_btn_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.btn_cancel") || "取消",
          type: "warning",
        }
      ).then(() => {
        this.$api.systemDictionaryDelApi({ keyID: code }).then((res) => {
          this.$message({
            showClose: true,
            message: this.$l("INDEX.tips_delete_ok") || res.msg,
            type: "success",
          });
          this.$emit("reload");
        });
      });
    },
  },
};
</script>
